const t = (e) => e ? e.replace(/<[^>]*>/g, "").trim() === "" : !0, r = [
  ["bold", "italic", "underline", "strike", "clean"],
  ["unorderedList", "orderedList"],
  ["link", "image", "video"],
  ["codeBlock", "blockquote"]
], n = [
  ["bold", "italic", "underline", "clean"],
  ["link"]
];
export {
  r as CONTROLS,
  n as SIMPLE_CONTROLS,
  t as isEmpty
};
